<template>
    <div>
        <header class="header">
            <div class="logo">
                <a :href="plcUri" class="logo__link logo__link--sm">
                    <svg height="24px" width="50px" class="logo__img logo__img--sm">
                        <use xlink:href="#logo-plc"></use>
                    </svg>
                </a>
                <router-link to="/" class="logo__link">
                    <img src="./assets/img/logo.png" class="logo__img" alt="Platincoin Block Explorer">
                </router-link>
            </div>
            <search>
                <div class="headerSearch" id="commonSearchForm" slot-scope="{ search_form, searchId, onInput }">
                    <input :value="search_form"
                           @input="onInput"
                           @keyup.enter="searchId"
                           class="headerSearch__input" id="commonSearchInput"
                           type="text" placeholder="Enter a block height, address, block hash or transaction hash." required="">
                    <button @click="searchId"
                            class="headerSearch__button" id="searchLink"
                            type="submit">Search</button>
                </div>
            </search>
        </header>

        <search>
            <div class="headerSearch headerSearch--sm" id="commonSearchForm2" slot-scope="{ search_form, searchId, onInput }">
                <input :value="search_form"
                       @input="onInput"
                       @keyup.enter="searchId"
                       class="headerSearch__input" id="commonSearchInput2"
                       type="text" placeholder="Enter a block height, address, block hash or transaction hash." required="">
                <button @click="searchId"
                        class="headerSearch__button" id="searchLink2"
                        type="submit">
                    <img src="./assets/img/search.png" class="headerSearch__icon">
                </button>
            </div>
        </search>

        <main class="content">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-12">
                <router-view></router-view>
              </div>
            </div>
          </div>
        </main>

        <!-- Vue2-Simplert DOM start -->
        <simplert :useRadius="true"
                  :useIcon="true"
                  ref="simplert">
        </simplert>

        <div id="alertArea"></div>
    </div>
</template>

<script>
import Search from './components/base/Search'

export default {
  name: 'App',

  components: { Search },

  data: () => ({
    plcUri: process.env.PLC_URI
  })
}
</script>

<style lang="scss">
  $table-border-width: 0px;

  @import "~normalize-scss/sass/normalize";
  @import "~bootstrap/scss/bootstrap";
  @import "assets/sass/main.scss";

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue